import { __assign, __rest } from "tslib";
import React from 'react';
import { transformWireframeProps } from '../../../../../utils/propUtils';
import VeltCommentDialogAgentSuggestionMenuTriggerWireframe from './VeltCommentDialogAgentSuggestionMenuTriggerWireframe/VeltCommentDialogAgentSuggestionMenuTriggerWireframe';
import VeltCommentDialogAgentSuggestionMenuContentWireframe from './VeltCommentDialogAgentSuggestionMenuContentWireframe/VeltCommentDialogAgentSuggestionMenuContentWireframe';
var VeltCommentDialogAgentSuggestionMenuWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comment-dialog-agent-suggestion-menu-wireframe", __assign({}, transformedProps), children));
};
VeltCommentDialogAgentSuggestionMenuWireframe.Trigger = VeltCommentDialogAgentSuggestionMenuTriggerWireframe;
VeltCommentDialogAgentSuggestionMenuWireframe.Content = VeltCommentDialogAgentSuggestionMenuContentWireframe;
export default VeltCommentDialogAgentSuggestionMenuWireframe;
